module.exports = __webpack_public_path__ + "img/YFPO_Logo.6fda308c.png";